
export const ADD_PRODUCT_CART_REQUEST='ADD_PRODUCT_CART_REQUEST'
export const ADD_PRODUCT_CART_SUCCESS='ADD_PRODUCT_CART_SUCCESS'
export const ADD_PRODUCT_CART_FAILURE='ADD_PRODUCT_CART_FAILURE'

export const FETCH_CART_REQUEST='FETCH_CART_REQUEST'
export const FETCH_CART_SUCCESS='FETCH_CART_SUCCESS'
export const FETCH_CART_FAILURE='FETCH_CART_FAILURE'

export const REMOVE_PRODUCT_CART_REQUEST='REMOVE_PRODUCT_CART_REQUEST'
export const REMOVE_PRODUCT_CART_SUCCESS='REMOVE_PRODUCT_CART_SUCCESS'
export const REMOVE_PRODUCT_CART_FAILURE='REMOVE_PRODUCT_CART_FAILURE'

export const ADD_ORDER_REQUEST='ADD_ORDER_REQUEST'
export const ADD_ORDER_SUCCESS='ADD_ORDER_SUCCESS'
export const ADD_ORDER_FAILURE='ADD_ORDER_FAILURE'

export const EMPTY_CART_REQUEST='EMPTY_CART_REQUEST'
export const EMPTY_CART_SUCCESS='EMPTY_CART_SUCCESS'
export const EMPTY_CART_FAILURE='EMPTY_CART_FAILURE'

export const FETCH_ORDERS_REQUEST='FETCH_ORDERS_REQUEST'
export const FETCH_ORDERS_SUCCESS='FETCH_ORDERS_SUCCESS'
export const FETCH_ORDERS_FAILURE='FETCH_ORDERS_FAILURE'
